import { importJobInitialState } from './importJob.initialState';
import { path, pathOr } from 'ramda';
import { createSelector } from 'reselect';

export const getPendingImportJobUpdate = state => path(['importJob', 'pendingUpdate'], state);
export const getPendingImportJobCreate = state => path(['importJob', 'pendingCreate'], state);
export const getPendingImportJobFetch = state => path(['importJob', 'pendingFetch'], state);
export const getPendingImportJobs = state => ({
	update: getPendingImportJobUpdate(state),
	create: getPendingImportJobCreate(state),
	fetch: getPendingImportJobFetch(state),
});

export const getImportJobErrorUpdate = state => path(['importJob', 'updateError'], state);
export const getImportJobErrorCreate = state => path(['importJob', 'createError'], state);
export const getImportJobErrors = state => ({
	update: getImportJobErrorUpdate(state),
	create: getImportJobErrorCreate(state),
});

export const getImportJobById = (state, id) =>
	pathOr({}, ['importJob', 'entities'], state)[id] || importJobInitialState;
export const getEntities = state => path(['importJob', 'entities'], state);
export const getImportJobs = createSelector(getEntities, entities => Object.values(entities));

// in our onboarding, we only care about the special 'inital import' job
export const getInitialImportJobs = createSelector(getEntities, entities =>
	Object.values(entities).filter(entity => entity.initialImport === true),
);



// WEBPACK FOOTER //
// ./src/redux/importJobs/importJob.selector.js